import { checkHttpStatusAuthCheck } from '../../../../../../../actions/utilAction';
import { actionCreator, masterCriteriaActionTypes, checkHttpStatus, jsonApiHeader, POST_PATIENT_MASTER_CRITERIA_API, showErrorMessage, showSuccessMessage, GET_PATIENT_MASTER_CRITERIA_API, GET_MASTERDATABYNAME } from '../constants/ApiConstants';


export const getMasterData = (masterData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterCriteriaActionTypes.get_masterData.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify(masterData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function (response) {
        dispatch(actionCreator(masterCriteriaActionTypes.get_masterData.SUCCESS, response));
      })
      .catch(function (error) {
        console.log('error getMasterData ..', error);
      });
  };
};

export const getPatientMasterCriteriaDetail = (patientId) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterCriteriaActionTypes.get_patientMasterCriteria.REQUEST));
    fetch(`${GET_PATIENT_MASTER_CRITERIA_API}?patientId=${patientId}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          dispatch(actionCreator(masterCriteriaActionTypes.get_patientMasterCriteria.SUCCESS, response));
        } else {
          dispatch(actionCreator(masterCriteriaActionTypes.get_patientMasterCriteria.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error get_patientMasterCriteria', error);
      });
  };
};

export const savePatientMasterCriteria = (formProps) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(masterCriteriaActionTypes.save_patientMasterCriteria.REQUEST));
    fetch(`${POST_PATIENT_MASTER_CRITERIA_API}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(formProps),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(masterCriteriaActionTypes.save_patientMasterCriteria.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(masterCriteriaActionTypes.save_patientMasterCriteria.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error save_patientMasterCriteria', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/SetUp/masteryCriteria/actions/MasterCriteriaActions.js